module.exports = __webpack_public_path__ + "img/Jennifer&Marcus-05.c8fa39ab.jpg";